var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (locale, user, votable) {
      if (user.username) {
pug_html = pug_html + "\u003Ca" + (" class=\"video-engagement__comment-button-trigger js-component\""+" data-component=\"CommentButton\" href=\"#new_comment\""+pug.attr("title", locale.comments, true, true)+" data-loaded=\"true\" data-original-title=\"\"") + "\u003E" + (pug.escape(null == (pug_interp = locale.comments) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"video-engagement__comment-button-trigger js-component\""+" data-component=\"RequireLoginModal\" data-title=\"\""+pug.attr("data-url", '/users/login?user_return_to=' + votable.path, true, true)+" href=\"#new_comment\" rel=\"nofollow\""+pug.attr("title", locale.comments, true, true)+" data-loaded=\"true\" data-original-title=\"\"") + "\u003E" + (pug.escape(null == (pug_interp = locale.comments) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
    }.call(this, "locale" in locals_for_with ?
        locals_for_with.locale :
        typeof locale !== 'undefined' ? locale : undefined, "user" in locals_for_with ?
        locals_for_with.user :
        typeof user !== 'undefined' ? user : undefined, "votable" in locals_for_with ?
        locals_for_with.votable :
        typeof votable !== 'undefined' ? votable : undefined));
    ;;return pug_html;};
module.exports = template;